import * as React from 'react'
import NumberFieldInnerTable from '../../inputs/NumberFieldInnerTable'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const PkkMembership = ({ data, setData }) => {
  const { t } = useLocalize()
  return (
    <div className="tw-flex tw-w-full tw-flex-col tw-items-end tw-justify-between tw-gap-2 tw-px-5 tw-pt-3">
      <NumberFieldInnerTable
        fullWidth
        label={t('contract.ppk-employee-share')}
        innerLabel="%"
        placeholder="0,00"
        value={data?.ppkEmployee?.toString() || ''}
        onChange={(e) => {
          setData({ ...data, ppkEmployee: Number(e.target.value) })
        }}
      />
      <NumberFieldInnerTable
        fullWidth
        label={t('contract.ppk-employer-share')}
        innerLabel="%"
        placeholder="0,00"
        value={data?.ppkEmployer?.toString() || ''}
        onChange={(e) => {
          setData({ ...data, ppkEmployer: Number(e.target.value) })
        }}
      />
    </div>
  )
}

export default PkkMembership
